import { Flex } from "@chakra-ui/react";
import { ImpersonatingBanner } from "components/ImpersonatingBanner";
import { Footer } from "components/Navigation/Footer";
import { NavHeader } from "components/Navigation/NavHeader";
import { useAuthCookiePersistence } from "hooks/useAuthCookiePersistence";
import { Outlet } from "react-router-dom";
import InAppLayout from "./InAppLayout";

const PublicLayout = ({ children }: any) => {
    const { isInWebView } = useAuthCookiePersistence();

    // Page is loaded from within the mobile app, use the app-specific layout instead
    if (isInWebView) {
        return <InAppLayout>
            {children}
        </InAppLayout>
    }

    return (
        <Flex flexDir="column" minHeight="100vh" bg="white" color="black">
            <ImpersonatingBanner />
            <NavHeader />
            <Flex flex={1} h="100%">
                {children ? children : <Outlet />}
            </Flex>
            <Footer />
        </Flex>
    );
};

export default PublicLayout;
